import {
	ICSDDailyUpdateDetailedSummaryGridDetail,
	ICSDDailyUpdateSummaryGridDetail,
	ICSDSupplierCompanyName,
	ICSDSupplierMaaaNumber,
	ICSDSupplierMaintenanceSummaryGridDetail,
	ISupplierIntegrationNumber,
	ISupplierMaaNumber,
	IValidationResponse,
} from "./../models/CSDIntegration/CSDIntegrationModel";
import { BaseService } from "./base.service";

import { TableFilterModel } from "models/TableFilterModel";
import {
	ICSDSegmentSummaryGridDetail,
	ICSDFamilySummaryGridDetail,
	ICSDClassSummaryGridDetail,
	ICSDCommoditySummaryGridDetail,
	ICSDCommodityTilesCountDetail,
	ICSDSegment,
	ICSDFamily,
	ICSDClass,
	ICSDCommodity,
} from "models/CSDIntegration/CSDIntegrationModel";
import { IItemNameModel } from "models/Item/ItemNameModel";
import { KeyFilterModel } from "models/SystemScheduler/SystemSchedulerFilterModel";
import { ITableNumberColumnFilter } from "models/TableNumberColumnFilter";

class CSDCommodityServiceInternal extends BaseService {
	getCommodityByItemId = async (itemIds: string): Promise<ICSDCommodity[]> =>
		this.callApi<ICSDCommodity[]>(
			`CsdCommodity/GetCommodityByItemId/${itemIds}`,
			"GET"
		);

	getCommoditiesByContractId = async (
		contractId: number,
		itemId: number
	): Promise<ICSDCommodity[]> =>
		this.callApi<ICSDCommodity[]>(
			`ContractLine/GetCommoditiesByContractId/${contractId}/${itemId}`,
			"GET"
		);

	getCsdSegmentGridList = async (
		model: TableFilterModel
	): Promise<ICSDSegmentSummaryGridDetail[]> =>
		this.callApi<ICSDSegmentSummaryGridDetail[]>(
			`CsdSegment/GetCsdSegmentList`,
			"POST",
			undefined,
			model
		);

	getCsdFamilyGridList = async (
		model: TableFilterModel
	): Promise<ICSDFamilySummaryGridDetail[]> =>
		this.callApi<ICSDFamilySummaryGridDetail[]>(
			`CsdFamily/GetCsdFamilyList`,
			"POST",
			undefined,
			model
		);

	getCsdClassGridList = async (
		model: TableFilterModel
	): Promise<ICSDClassSummaryGridDetail[]> =>
		this.callApi<ICSDClassSummaryGridDetail[]>(
			`CsdClass/GetCsdClassList`,
			"POST",
			undefined,
			model
		);

	getCsdCommodityGridList = async (
		model: TableFilterModel
	): Promise<ICSDCommoditySummaryGridDetail[]> =>
		this.callApi<ICSDCommoditySummaryGridDetail[]>(
			`CsdCommodity/GetCsdCommodityList`,
			"POST",
			undefined,
			model
		);

	getCsdTilesCountDetail = async (
		model: TableFilterModel
	): Promise<ICSDCommodityTilesCountDetail> =>
		this.callApi<ICSDCommodityTilesCountDetail>(
			`CsdCommodity/GetCsdCommodityTilesCount`,
			"POST",
			undefined,
			model
		);

	updatePurchaseCategoryAndItem = async (
		csdClassId: number,
		purchaseCategoryId: number,
		itemIds: number[]
	): Promise<number> =>
		this.callApi<number>(`CsdClass/Update/${csdClassId}`, "POST", undefined, {
			purchaseCategoryId: purchaseCategoryId,
			itemIds: itemIds,
		});

	updateCsdSegmentStatus = async (
		csdSegmentId: number,
		isActive: boolean
	): Promise<number> =>
		this.callApi<number>(
			`CsdSegment/updateCsdSegmentStatus/${csdSegmentId}`,
			"POST",
			new URLSearchParams({
				isActive: isActive.toString(),
			})
		);

	updateCsdFamilyStatus = async (
		csdFamilyId: number,
		isActive: boolean
	): Promise<number> =>
		this.callApi<number>(
			`CsdFamily/updateCsdFamilyStatus/${csdFamilyId}`,
			"POST",
			new URLSearchParams({
				isActive: isActive.toString(),
			})
		);

	updateCsdClassStatus = async (
		csdClassId: number,
		isActive: boolean
	): Promise<number> =>
		this.callApi<number>(
			`CsdClass/updateCsdClassStatus/${csdClassId}`,
			"POST",
			new URLSearchParams({
				isActive: isActive.toString(),
			})
		);

	updateCsdCommodityStatus = async (
		csdCommodityId: number,
		isActive: boolean
	): Promise<number> =>
		this.callApi<number>(
			`CsdCommodity/updateCsdCommodityStatus/${csdCommodityId}`,
			"POST",
			new URLSearchParams({
				isActive: isActive.toString(),
			})
		);

	getCsdSegmentList = async (
		model = new TableFilterModel()
	): Promise<ICSDSegment[]> =>
		this.callApi<ICSDSegment[]>(`CsdSegment/GetAll`, "POST", undefined, model);

	getCsdFamilyList = async (model: TableFilterModel): Promise<ICSDFamily[]> =>
		this.callApi<ICSDFamily[]>(
			`CsdFamily/GetCsdFamilyByCsdSegmentId`,
			"POST",
			undefined,
			model
		);

	getCsdClassList = async (
		model = new TableFilterModel()
	): Promise<ICSDClass[]> =>
		this.callApi<ICSDClass[]>(
			`CsdClass/GetCsdClassByCsdFamilyId`,
			"POST",
			undefined,
			model
		);

	getCsdCommodityList = async (
		model = new TableFilterModel()
	): Promise<ICSDCommodity[]> =>
		this.callApi<ICSDCommodity[]>(
			`CsdCommodity/GetCsdCommodityByCsdClassId`,
			"POST",
			undefined,
			model
		);

	getItemByCsdClassId = async (
		model: KeyFilterModel
	): Promise<IItemNameModel[]> =>
		this.callApi<IItemNameModel[]>(
			`CsdClass/GetItemByCsdClassId`,
			"POST",
			undefined,
			model
		);

	getCsdSupplierMaintenanceGridList = async (
		model: TableFilterModel
	): Promise<ICSDSupplierMaintenanceSummaryGridDetail[]> =>
		this.callApi<ICSDSupplierMaintenanceSummaryGridDetail[]>(
			`Supplier/GetCsdSupplierMaintenanceGridList`,
			"POST",
			undefined,
			model
		);

	getCsdSupplierMaaaNumberList = async (
		model: ITableNumberColumnFilter
	): Promise<ICSDSupplierMaaaNumber[]> =>
		this.callApi<ICSDSupplierMaaaNumber[]>(
			`Supplier/GetCsdSupplierMaaaNumberList`,
			"POST",
			undefined,
			model
		);

	getSupplierCompanyNameList = async (
		model: ITableNumberColumnFilter
	): Promise<ICSDSupplierCompanyName[]> =>
		this.callApi<ICSDSupplierCompanyName[]>(
			`Supplier/GetCsdSupplierCompanyNameList`,
			"POST",
			undefined,
			model
		);

	getValidationResponseList = async (): Promise<IValidationResponse[]> =>
		this.callApi<IValidationResponse[]>(
			`Supplier/GetValidationResponseList`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			true
		);

	// CSD Daily Update APIs START
	getCsdDailyUpdateGridList = async (
		model: TableFilterModel
	): Promise<ICSDDailyUpdateSummaryGridDetail[]> =>
		this.callApi<ICSDDailyUpdateSummaryGridDetail[]>(
			`SupplierIntegrationLogHistory/GetCsdDailyUpdateGridList`,
			"POST",
			undefined,
			model,
			undefined,
			undefined,
			true
		);

	getSupplierIntegrationNumberList = async (
		model: ITableNumberColumnFilter
	): Promise<ISupplierIntegrationNumber[]> =>
		this.callApi<ISupplierIntegrationNumber[]>(
			`SupplierIntegrationLogHistory/GetSupplierIntegrationNumberList`,
			"POST",
			undefined,
			model,
			undefined,
			undefined,
			true
		);

	getCsdDailyUpdateDetailedGridList = async (
		model: TableFilterModel
	): Promise<ICSDDailyUpdateDetailedSummaryGridDetail[]> =>
		this.callApi<ICSDDailyUpdateDetailedSummaryGridDetail[]>(
			`SupplierIntegrationLogHistory/GetCsdDailyUpdateDetailsGridList`,
			"POST",
			undefined,
			model,
			undefined,
			undefined,
			true
		);

	getDailyUpdateMaaaNumberList = async (
		model: ITableNumberColumnFilter
	): Promise<ISupplierMaaNumber[]> =>
		this.callApi<ISupplierMaaNumber[]>(
			`SupplierIntegrationLogHistory/GetDailyUpdateMaaaNumberList`,
			"POST",
			undefined,
			model,
			undefined,
			undefined,
			true
		);

	// CSD Daily Update APIs END
}

export const CSDCommodityService = new CSDCommodityServiceInternal();
